import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, TextSearchResultsProps } from 'component/common/TextSearch/TextSearchResult/TextSearchResults.selectors';
import { TextSearchLoadingPlaceholder } from 'component/common/TextSearch/TextSearchResult/TextSearchLoadingPlaceholder';
import TextSearchResultItems from 'component/common/TextSearch/TextSearchResult/TextSearchResultItems';
import EmptyStateSuggestion from 'component/common/TextSearch/TextSearchResult/EmptyStateSuggestion/EmptyStateSuggestion';
import TextSearchNoResults from 'component/common/TextSearch/TextSearchResult/TextSearchNoResults/TextSearchNoResults';

const TextSearchResults: React.FC<TextSearchResultsProps> = React.memo((props) => {
    const { searchText, screenSize, onSelect, isSearchBoxFeatureGroup, popularActivities, isInCitySearch, config, areSuggestionsLoading, suggestions } = props;
    const { geo, cms, isMockData } = config;

    if (searchText === '' && isInCitySearch && popularActivities && popularActivities.length > 0) {
        return null;
    }

    if (searchText === '' && isSearchBoxFeatureGroup && geo?.topDestinations && geo?.topDestinations?.length > 0 && (!popularActivities || popularActivities.length === 0)) {
        return <EmptyStateSuggestion />;
    }

    if (!isMockData && areSuggestionsLoading) {
        return <TextSearchLoadingPlaceholder />;
    }

    const isEmptySuggestions = !suggestions || suggestions.length === 0;
    if (isEmptySuggestions) {
        return <TextSearchNoResults searchText={searchText} cms={cms} isGlobalKeywordSearch={props.isGlobalKeywordSearch} />;
    }

    return (
        <TextSearchResultItems
            results={suggestions}
            onSelect={onSelect}
            searchText={searchText}
            cms={cms}
            isInCitySearch={isInCitySearch}
            screenSize={screenSize}
            isSearchBoxFeatureGroup={isSearchBoxFeatureGroup}
        />
    );
});
TextSearchResults.displayName = 'TextSearchResults';

export default connect(mapStateToProps)(TextSearchResults);
